module.exports = require('scryptsy')



//////////////////
// WEBPACK FOOTER
// ./node_modules/scrypt.js/js.js
// module id = 1157
// module chunks = 0